<template>
  <div class="shop">
    <h1>Shop</h1>
    <div class="items">
      <Item v-for="item in items" v-bind="item" :key="item.name"> </Item>
    </div>
  </div>
</template>

<script>
import Item from "./Item";

export default {
  name: "Shop",
  props: {
    items: Array,
    name: String
  },
  components: { Item },
  mounted() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.shop {
  min-width: 20rem;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: white;
}
.items {
  overflow-y: scroll;
  scrollbar-width: none;
  scroll-behavior: smooth;
  height: 100%;
}
::-webkit-scrollbar {
  display: none;
}
h1 {
  font-family: "Montserrat", sans-serif;
  padding: 0px;
  margin: 0px;
  text-align: center;
  border-bottom: solid 0.2rem black;
}
</style>
